module.exports = __webpack_public_path__ + "img/bahamas.96733958.svg";